import { onMounted, onBeforeUnmount, ref } from 'vue'

export function usePrintDetection() {
    // Function to handle the before print event

    const printing = ref(false)
    const handleBeforePrint = () => {
        printing.value = true
    };

    // Function to handle the after print event
    const handleAfterPrint = () => {
        printing.value = false;
    };

    // Set up the event listeners in the lifecycle hooks
    onMounted(() => {
        window.addEventListener('beforeprint', handleBeforePrint);
        window.addEventListener('afterprint', handleAfterPrint);
    });

    // Clean up event listeners on component unmount
    onBeforeUnmount(() => {
        window.removeEventListener('beforeprint', handleBeforePrint);
        window.removeEventListener('afterprint', handleAfterPrint);
    });

    return {printing}
}
